import {
  FETCH_ROTA,
  FETCH_ROTA_FAILURE,
  FETCH_ROTA_SUCCESS,
  UPDATE_ROTA,
  //
  BULK_PUBLISH,
  BULK_PUBLISH_SUCCESS,
  BULK_PUBLISH_FAILURE,
  //
  FETCH_ROTA_STAT,
  FETCH_ROTA_STAT_SUCCESS,
  FETCH_ROTA_STAT_FAILURE,
  UPDATE_STAT,
  //
  FETCH_SHIFTS,
  FETCH_SHIFTS_SUCCESS,
  FETCH_SHIFTS_FAILURE,
  UPDATE_SHIFTS,
  //
  TOGGLE_PRINT,
  //
  SET_ALLOC_FILTERS,
} from "./constants";

export const fetchRota = (payload, onSuccess) => ({
  type: FETCH_ROTA,
  payload,
  onSuccess,
});
export const fetchRotaSuccess = (payload) => ({
  type: FETCH_ROTA_SUCCESS,
  payload,
});
export const fetchRotaFailure = (payload) => ({
  type: FETCH_ROTA_FAILURE,
  payload,
});

export const bulkPublish = (payload, onPublishSuccess) => ({
  type: BULK_PUBLISH,
  payload,
  onPublishSuccess,
});
export const bulkPublishSuccess = (payload) => ({
  type: BULK_PUBLISH_SUCCESS,
  payload,
});
export const bulkPublishFailure = (payload) => ({
  type: BULK_PUBLISH_FAILURE,
  payload,
});

export const fetchRotaStat = (payload) => ({
  type: FETCH_ROTA_STAT,
  payload,
});
export const fetchRotaStatSuccess = (payload) => ({
  type: FETCH_ROTA_STAT_SUCCESS,
  payload,
});
export const fetchRotaStatFailure = (payload) => ({
  type: FETCH_ROTA_STAT_FAILURE,
  payload,
});

export const fetchShifts = (payload) => ({
  type: FETCH_SHIFTS,
  payload,
});
export const fetchShiftsSuccess = (payload) => ({
  type: FETCH_SHIFTS_SUCCESS,
  payload,
});
export const fetchShiftsFailure = (payload) => ({
  type: FETCH_SHIFTS_FAILURE,
  payload,
});
export const updateShifts = (payload) => ({
  type: UPDATE_SHIFTS,
  payload,
});
export const updateStat = (payload) => ({
  type: UPDATE_STAT,
  payload,
});
export const updateRota = (payload) => ({
  type: UPDATE_ROTA,
  payload,
});
//
export const togglePrint = (payload) => ({
  type: TOGGLE_PRINT,
  payload,
});
export const setAllocFilters = (payload) => ({
  type: SET_ALLOC_FILTERS,
  payload,
});
